import React from 'react'
import { GfmLeaderboard, GfmLeaderboardProps } from '@classy/campaign-page-blocks'

export const GfmLeaderboardController = ({ data = {}, ...rest }: GfmLeaderboardProps) => (
  <GfmLeaderboard data={data} {...rest} />
)
